import { motion } from "framer-motion";
import { MEDIA } from "../lib/media";

const MENU_CATEGORIES = [
  {
    title: "Platillos Destacados",
    image: MEDIA.foodPlatter,
    items: [
      { name: "Burrito", price: "$6.75" },
      { name: "Nachos con Chicharrones", price: "$9.50" },
      { name: "Taquitos Fritos", price: "$8.85" },
    ],
  },
  {
    title: "Especialidades",
    subtitle: "Bebidas con carácter",
    image: "https://customer-assets.emergentagent.com/job_hospedaje-gourmet/artifacts/9bqmi6ik_Suchimex0480.jpg",
    items: [
      { name: "La Vampira", price: "$7.75" },
      { name: "Cazuela de Cítricos", price: "desde $9.75" },
      { name: "Beso de Alacrán", price: "$7.75" },
    ],
  },
  {
    title: "Bebidas",
    image: MEDIA.coffePastry,
    items: [
      { name: "Limonada Rosa", price: "$4.50" },
      { name: "Jugo de Naranja", price: "$3.85" },
      { name: "Ponche de Frutas", price: "$3.85" },
    ],
  },
];

export const MenuSection = () => {
  return (
    <section id="menu" data-testid="menu-section" className="py-24 md:py-32 bg-[#2D2A26] relative overflow-hidden">
      {/* Texture */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `url(${MEDIA.terracottaTexture})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="overline text-[#A25F4B] mb-4">Sabores</p>
          <h2
            data-testid="menu-title"
            className="font-heading text-4xl md:text-5xl tracking-tight text-[#FAF7F2]"
          >
            Menú Destacado
          </h2>
        </motion.div>

        {/* Visual Menu Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MENU_CATEGORIES.map((category, catIdx) => (
            <motion.div
              key={catIdx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: catIdx * 0.15 }}
              data-testid={`menu-category-${catIdx}`}
              className="group relative flex flex-col"
            >
              {/* Image */}
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                {/* Content over image */}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h3 className="font-heading text-2xl md:text-3xl text-[#FAF7F2] tracking-tight mb-1">
                    {category.title}
                  </h3>
                  {category.subtitle && (
                    <p className="text-[#FAF7F2]/50 font-body text-xs mb-5">{category.subtitle}</p>
                  )}
                  {!category.subtitle && <div className="mb-4" />}

                  <div className="space-y-3">
                    {category.items.map((item, itemIdx) => (
                      <div
                        key={itemIdx}
                        data-testid={`menu-item-${catIdx}-${itemIdx}`}
                        className="flex justify-between items-baseline border-b border-[#FAF7F2]/10 pb-2.5"
                      >
                        <span className="text-[#FAF7F2] font-body font-medium text-sm">
                          {item.name}
                        </span>
                        <span className="text-[#FAF7F2] font-body font-bold text-sm ml-3 whitespace-nowrap">
                          {item.price}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-12 space-y-4"
        >
          <a
            href="https://drive.google.com/file/d/1mple6-Br5agmk7h8X32byPCPLAjHXIET/view"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="menu-cta-completo"
            className="overline text-[0.7rem] bg-[#FAF7F2] text-[#2D2A26] px-10 py-3.5 hover:bg-[#EBE3D5] transition-all duration-300 hover:-translate-y-0.5 inline-block"
          >
            Ver Menú Completo
          </a>
          <p className="text-[#FAF7F2]/40 font-body text-sm">
            Menú completo disponible en el restaurante
          </p>
        </motion.div>
      </div>
    </section>
  );
};
